import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_LABORATORIES_LOAD,
    ACTION_LABORATORIES_LOAD_BY_ID,

    ACTION_LABORATORIES_SAVE,

    ACTION_LABORATORIES_CREATE,

    ACTION_LABORATORIES_VALIDATE,

    ILaboratoriesLoadAction,
    ILaboratoryLoadByIdAction,
    ILaboratoryLoadFailureAction,
    ILaboratoryLoadSuccessAction,

    ILaboratorySaveAction,
    ILaboratorySaveSuccessAction,
    ILaboratorySaveFailureAction,

    ILaboratoryCreateAction,
    ILaboratoryCreateSuccessAction,
    ILaboratoryCreateFailureAction,

    ILaboratoryValidateAction,
    ILaboratoryValidateSuccessAction,
    ILaboratoryValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/laboratories";
import { laboratoriesApi } from "../services/laboratories";


export const
    getLaboratoriesEpic = (action$): Observable<ILaboratoryLoadSuccessAction | ILaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORIES_LOAD)
            .mergeMap((_action: ILaboratoriesLoadAction) => {
                return laboratoriesApi
                    .getLaboratories()
                    .map(response =>
                        LoadSuccess(response.laboratories, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getLaboratoryByIdEpic = (action$): Observable<ILaboratoryLoadSuccessAction | ILaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORIES_LOAD_BY_ID)
            .mergeMap((action: ILaboratoryLoadByIdAction) => {
                return laboratoriesApi
                    .getLaboratoryById(action.id)
                    .map(response =>
                        LoadSuccess(response.laboratory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setLaboratoryEpic = (action$): Observable<ILaboratorySaveSuccessAction | ILaboratorySaveFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORIES_SAVE)
            .mergeMap((action: ILaboratorySaveAction) => {
                return laboratoriesApi
                    .setLaboratory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.laboratory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createLaboratoryEpic = (action$): Observable<ILaboratoryCreateSuccessAction | ILaboratoryCreateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORIES_CREATE)
            .mergeMap((_action: ILaboratoryCreateAction) => {
                return laboratoriesApi
                    .createLaboratory()
                    .map(response =>
                        CreateSuccess(response.laboratory, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateLaboratoryEpic = (action$): Observable<ILaboratoryValidateSuccessAction | ILaboratoryValidateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORIES_VALIDATE)
            .mergeMap((action: ILaboratoryValidateAction) => {
                return laboratoriesApi
                    .validateLaboratory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.laboratory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }